



export const GET_ALL_BLOG_REQUEST = "GET_ALL_BLOG_REQUEST"
export const GET_ALL_BLOG_SUCCESS = "GET_ALL_BLOG_SUCCESS"
export const GET_ALL_BLOG_FAILURE = "GET_ALL_BLOG_FAILURE"


export const GET_USER_BLOG_REQUEST = "GET_USER_BLOG_REQUEST"
export const GET_USER_BLOG_SUCCESS = "GET_USER_BLOG_SUCCESS"
export const GET_USER_BLOG_FAILURE = "GET_USER_BLOG_FAILURE"


export const ADD_USER_BLOG_REQUEST = "ADD_USER_BLOG_REQUEST"
export const ADD_USER_BLOG_SUCCESS = "ADD_USER_BLOG_SUCCESS"
export const ADD_USER_BLOG_FAILURE = "ADD_USER_BLOG_FAILURE"


export const EDIT_USER_BLOG_REQUEST = "EDIT_USER_BLOG_REQUEST"
export const EDIT_USER_BLOG_SUCCESS = "EDIT_USER_BLOG_SUCCESS"
export const EDIT_USER_BLOG_FAILURE = "EDIT_USER_BLOG_FAILURE"


export const DELETE_USER_BLOG_REQUEST = "DELETE_USER_BLOG_REQUEST"
export const DELETE_USER_BLOG_SUCCESS = "DELETE_USER_BLOG_SUCCESS"
export const DELETE_USER_BLOG_FAILURE = "DELETE_USER_BLOG_FAILURE"
